import { atom } from "recoil"

// Save selected row ids
export const packagesRowIdsState = atom({
  key: "packagesRowIdsState",
  default: {},
})

// Save old package list
export const packagesState = atom({
  key: "packagesState",
  default: [],
})
